import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { UrgencyModel } from './model';
import { urgencyAdapter, UrgencyState } from './state';

export const stateName: string = 'urgency';

export const getError = (state: UrgencyState): any => state.error;

export const getIsLoading = (state: UrgencyState): boolean => state.isLoading;

export const selectUrgencyState: MemoizedSelector<object, UrgencyState> = createFeatureSelector<UrgencyState>(stateName);

export const selectAll: (state: object) => UrgencyModel[] = urgencyAdapter.getSelectors(selectUrgencyState).selectAll;

export const selectById = (id: number) =>
  createSelector(selectAll, (urgency: UrgencyModel[]) => {
    return urgency ? urgency.find(p => p.id === id) : null;
  });

export const selectError: MemoizedSelector<object, any> = createSelector(selectUrgencyState, getError);

export const selectIsLoading: MemoizedSelector<object, boolean> = createSelector(selectUrgencyState, getIsLoading);
